import React from "react";
import { MDBRow, MDBContainer } from "mdbreact";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withUserContext } from "../../../contexts/UserContext";
import TableComponent from "../../../components/SharedComponents/Table";
import MessageModal from "../../../components/SharedComponents/MessageModal";
import * as Constants from "../../../constants/constants";
import PostWatchService from "../../../services/service";
import Message from "../../../Common/Messages.json";
import { lookupConfig } from "./Config";
import "./LookupMaster.scss";

class LookupMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      isLoading: false,
      isPosting: false,
      postInitiated: false,
      page: 1,
      rowsPerPage: 10,
      totalRows: 0,
      sortBy: null,
      sortOrder: "asc",
      a_z: false,
      config: JSON.parse(JSON.stringify(lookupConfig)),
      isMessageModalOpen: false,
      isErrorMessageModalOpen: false,
    };
  }

  componentDidMount() {
    this.getLookupDetails();
  }

  getLookupDetails = () => {
    this.setState({ isLoading: true });
    PostWatchService.getDataWithPath(
      Constants.postWatchServiceBaseUrl +
        "/getlookupdata?objectType=" +
        this.props?.lookupType +
        "&pageNo=" +
        this.state.page +
        "&pageCount=" +
        this.state.rowsPerPage +
        "&sortBy=" +
        (this.state.sortBy || "") +
        "&sortOrder=" +
        this.state.sortOrder,
      this.props?.userContext?.active_tenant?.tenant_id
    )
      .then((res) => {
        const list = (res?.data?.results || []).map((obj) => {
          obj.is_active = obj.is_active ? 0 : 1;
          return obj;
        });
        this.setState({
          list,
          totalRows: res?.data?.total_records_count,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({ isLoading: false });
      });
  };

  postData = (data) => {
    this.setState({ isPosting: true });
    PostWatchService.postDataParams(
      Constants.postWatchServiceBaseUrl +
        `/postlookupdata?userId=` +
        this.props?.userContext?.user_profile?.user_id,
      data,
      this.props?.userContext?.active_tenant?.tenant_id,
      1
    ).then(
      (response) => {
        if (response.data[0]?.Level === "Error") {
          this.setState({
            isErrorMessageModalOpen: true,
            isMessageModalOpen: false,
            isPosting: false,
          });
        } else {
          this.setState({
            isMessageModalOpen: false,
            isPosting: false,
            postInitiated: false,
          });
          this.deleteItem = null;
          this.getLookupDetails();
        }
      },
      (err) => {
        this.setState({ isPosting: false });
        console.log("Post lookup details error: " + err);
      }
    );
  };

  validateBeforeSave = (item) => item?.lookup_value?.trim().length > 0;

  handleInlineEdits = (id) => {
    this.state.list.forEach((item) => {
      if (item.lookup_data_id === id) item.editing = true;
    });
    this.setState((prevState) => ({ list: prevState.list }));
  };

  saveInlineEdits = (obj, index) => {
    const data = { ...obj[index] };
    data.is_active = data.is_active ? 0 : 1;
    if (this.validateBeforeSave(data)) {
      this.postData(data);
    }
  };

  handleAddNewItem = (newDataItem) => {
    this.setState({ postInitiated: true });
    if (this.validateBeforeSave(newDataItem)) {
      this.postData({
        is_active: newDataItem?.is_active ? 0 : 1,
        lookup_value: newDataItem?.lookup_value,
        lookup_type: this.props?.lookupType,
        tenant_id: this.props?.userContext?.active_tenant?.tenant_id,
      });
    }
  };

  handleDelCallBack = (id, dataItem) => {
    this.deleteItem = dataItem;
    this.setState({ isMessageModalOpen: true });
  };

  onModalConfirm = () => {
    this.postData({ ...this.deleteItem, is_deleted: 1 });
  };

  onErrorModalConfirm = () => {
    this.setState({ isErrorMessageModalOpen: false });
    this.deleteItem = null;
  };

  sortColumn = (headingLabel) => {
    const position = this.state.config.headings.findIndex(
      (heading) => heading.headingLabel === headingLabel
    );
    if (position < 0) return;
    const config = JSON.parse(JSON.stringify(this.state.config));
    const currentIcon = config.headings[position].icon;
    const ascending = !(this.state.a_z && currentIcon === "sort-alpha-down");
    config.headings.forEach((heading) => {
      heading.icon = "";
    });
    config.headings[position].icon = ascending
      ? "sort-alpha-down"
      : "sort-alpha-up";
    this.setState(
      {
        sortBy: config.dataNodes[position],
        sortOrder: ascending ? "asc" : "desc",
        a_z: ascending,
        config,
        page: 1,
      },
      this.getLookupDetails
    );
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage + 1 }, this.getLookupDetails);
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      { rowsPerPage: event.target.value, page: 1 },
      this.getLookupDetails
    );
  };

  render() {
    return (
      <div>
        <MDBContainer className="currencyContainer lookupMasterContainer">
          <MDBRow className="table-striped">
            {this.state.isPosting ? (
              <div className="ContentLoader">
                <CircularProgress />
              </div>
            ) : (
              <>
                <TableComponent
                  list={this.state.list}
                  className={"clearencRecord"}
                  config={this.state.config}
                  isLoading={this.state.isLoading}
                  sortCallback={this.sortColumn}
                  stickyHeader={true}
                  handleAddNewItem={this.handleAddNewItem}
                  editCallback={this.handleInlineEdits}
                  saveCallback={this.saveInlineEdits}
                  addItemToList={true}
                  showMandatory={this.state.postInitiated}
                  handleDelCallBack={this.handleDelCallBack}
                />
                <div className="Pagination">
                  <TablePagination
                    component="div"
                    count={this.state.totalRows}
                    rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                    page={this.state.page - 1}
                    onChangePage={this.handleChangePage}
                    rowsPerPage={this.state.rowsPerPage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </div>
              </>
            )}
          </MDBRow>
        </MDBContainer>
        {this.state.isMessageModalOpen && (
          <MessageModal
            open={this.state.isMessageModalOpen}
            showCustom={true}
            message={Message.deleteAdmin}
            title={"Confirm Deletion"}
            primaryButtonText={"Ok"}
            secondaryButtonText={"Cancel"}
            hideCancel={false}
            onConfirm={this.onModalConfirm}
            handleClose={() => this.setState({ isMessageModalOpen: false })}
          />
        )}
        {this.state.isErrorMessageModalOpen && (
          <MessageModal
            open={this.state.isErrorMessageModalOpen}
            showCustom={true}
            message={Message.deleteAdminError}
            title={"Message"}
            primaryButtonText={"Ok"}
            hideCancel={true}
            onConfirm={this.onErrorModalConfirm}
            handleClose={() => this.setState({ isErrorMessageModalOpen: false })}
          />
        )}
      </div>
    );
  }
}

export default withUserContext(LookupMaster);
